import ModalLogisticCreate from './ModalLogisticOriginCreate';
import ModalLogisticDelete from './ModalLogisticOriginDelete';
import ModalLogisticUpdate from './ModalLogisticOriginUpdate';

export default Object.assign(
  {},
  {
    Create: ModalLogisticCreate,
    Update: ModalLogisticUpdate,
    Delete: ModalLogisticDelete,
  },
);
